import routerOptions0 from "/home/vsts/work/1/s/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@24.0.3_db0@0.3.2_eslint@9.29.0_jiti@2.4.2_ca877518eaa3ed867bbf403e1039cb0f/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/vsts/work/1/s/apps/lobby/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}